import {
  sepolia,
  mainnet,
  apeChain,
  curtis,
  berachain,
  berachainBepolia,
  baseSepolia,
  base,
  monadTestnet,
} from 'viem/chains';
import { createConfig, http } from 'wagmi';
import { coinbaseWallet, injected } from 'wagmi/connectors';

import {
  ENERGI_MAINNET,
  ENERGI_TESTNET,
  SONEIUM_MAINNET,
  SONEIUM_TESTNET,
  ABSTRACT_MAINNET,
  ABSTRACT_TESTNET,
  SHIBARIUM_MAINNET,
  SHIBARIUM_TESTNET,
  TEN_TESTNET,
} from 'constants/chains';

const wagmiConfig = createConfig({
  chains: [
    mainnet,
    sepolia,
    apeChain,
    curtis,
    berachain,
    berachainBepolia,
    base,
    baseSepolia,
    ENERGI_MAINNET,
    ENERGI_TESTNET,
    SONEIUM_MAINNET,
    SONEIUM_TESTNET,
    ABSTRACT_MAINNET,
    ABSTRACT_TESTNET,
    SHIBARIUM_MAINNET,
    SHIBARIUM_TESTNET,
    TEN_TESTNET,
    monadTestnet,
  ],
  connectors: [
    injected(),
    coinbaseWallet({
      appName: 'GonnaMakeIt NFT Marketplace',
    }),
  ],
  transports: {
    [mainnet.id]: http('https://eth-mainnet.public.blastapi.io'),
    [sepolia.id]: http('https://eth-sepolia.public.blastapi.io'),
    [apeChain.id]: http('https://apechain.calderachain.xyz/http'),
    [curtis.id]: http('https://curtis.rpc.caldera.xyz/http'),
    [ENERGI_MAINNET.id]: http(),
    [ENERGI_TESTNET.id]: http(),
    [base.id]: http('https://mainnet.base.org'),
    [baseSepolia.id]: http('https://sepolia.base.org'),
    [berachain.id]: http('https://rpc.berachain.com'),
    [berachainBepolia.id]: http('https://bepolia.rpc.berachain.com'),
    [SONEIUM_MAINNET.id]: http('https://soneium.drpc.org'),
    [SONEIUM_TESTNET.id]: http('https://soneium-minato.drpc.org'),
    [ABSTRACT_MAINNET.id]: http('https://api.mainnet.abs.xyz'),
    [ABSTRACT_TESTNET.id]: http('https://api.testnet.abs.xyz'),
    [SHIBARIUM_MAINNET.id]: http('https://shibrpc.com'),
    [SHIBARIUM_TESTNET.id]: http('https://puppynet.shibrpc.com'),
    [TEN_TESTNET.id]: http(
      'https://testnet.ten.xyz/v1/?token=0xDBD075357B2F2A34DFD743007E42CF069786A70F',
    ),
    [monadTestnet.id]: http('https://testnet-rpc.monad.xyz'),
  },
});

export default wagmiConfig;
